import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'

import Form from './Form'
import ActionGet from '../../store/action/ReportButton/Fetch'
import ActionDownload from '../../store/action/ReportButton/Download'
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllDivision from "../../store/action/Division/FetchAll";
import CustomGrid from '../../infra/components/grid/custom-grid-without-search'
import "../../source/util.css"
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import { toast } from "react-toastify";
import {ClientId, DivisionId, PrevilageId, SenderId, SenderName} from "../../helper/HelperAuth";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import DatePickerInput from "../../infra/components/formInput/DatePickerInput";
import ActionGetAccessModuleIdAction from "../../store/action/AccessModule/FetchActionDispatch";
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId';
import { Modal } from 'react-bootstrap';

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "Report Button",
            form: fromJS({
                show : false,
                actionType: '',
                item: fromJS({})
            }),
            isadmin:false,
            formSearch: fromJS({
                "search": ""
            }),
            searchForm : fromJS({
                "client-id"     : '',
                "division-id"   : '',
                "status"        : 0,
                "start-date"    : '',
                "end-date"      : ''
            }),

            status : fromJS([
                {value : -1 , label : 'Failed'},
                {value : 1 , label : 'New Request'},
                {value : 2 , label : 'Processing'},
                {value : 3 , label : 'Completed'},
            ]),

            search: fromJS([
                { widthClass:'col-sm-12',id: 'search', placeholder: 'search', label : '', value:'' },
            ]),
            columns:[
                {  cfield: "counter", caption: "No" },
                {  field: "client-name", caption: "Client", allowSearch: true },
                {  field: "division-name", caption: "Division", allowSearch: true },
                {  cfield: "action", caption: "Filter Param",allowView: false, allowEdit: false, allowDelete: false ,
                link : fromJS([
                    {"id": "Hover","icon":"cloud_download", "label": "", "className": "btn-trans btn-sm waves-effect text-success"},
                ])
                },
                {  field: "request-date", caption: "Request Date", allowSearch: true },
                { field: "status", caption: "Status", allowSearch: true },
                { field: "reportFormatName", caption: "Report Format", allowSearch: true },
                {  
                    cfield: "action", caption: "Action Detail", allowView: false, allowEdit: false, allowDelete: false, className: "text-center",
                    custom : fromJS([
                        {"id": "Download","icon":"cloud_download", "label": "", "className": "btn-trans btn-sm waves-effect text-success"},
                        { "id": "Split", "icon": "cloud_download", "label": "Split File", "className": "btn btn-success btn-sm" },
                        {"id": "Refresh","icon":"refresh", "label": "", "className": "btn-trans btn-sm waves-effect text-success"},
                    ])
                },    
                {  
                    cfield: "action", caption: "Action Summary", allowView: false, allowEdit: false, allowDelete: false, className: "text-center",
                    custom : fromJS([
                        {"id": "Download2","icon":"cloud_download", "label": "", "className": "btn-trans btn-sm waves-effect text-success"},
                        {"id": "Refresh","icon":"refresh", "label": "", "className": "btn-trans btn-sm waves-effect text-success"},
                    ])
                },  
            ],
            errors: fromJS({}),
            actionId : "",
            disabledHead:true,
            modalShow: false,
            modalData: fromJS({}),
            modalType: "detail",
            modalReportLink: ""
        };
    
        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this); 
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.handleCustomAction = this.handleCustomAction.bind(this);
    }

    async componentDidMount(){
        this.props.actionGetAllClient()
        this.props.actionGetAccessModuleIdAction('Report Button');
        var isAdmin = await this.props.actionFindByGroupId()
        this.setState({isadmin:isAdmin})
    }

    async settingActionId(){
        var valueActionId = this.state.actionId;
        if(valueActionId ===null || valueActionId===undefined || valueActionId===''){
            var varActionId = "";
            var dataAkses =null;
            setTimeout(() => {
                dataAkses = this.props.accessmoduleaction;
                if(dataAkses){
                    varActionId=dataAkses.get("action-id");
                    if(varActionId==5){
                        this.props.actionGetAllDivision(ClientId);
                        var formVal = this.state.searchForm;
                        formVal = formVal.set('client-id',ClientId).set('division-id',DivisionId);
                        this.setState({
                            searchForm: formVal,
                            disabledHead: true,
                            actionId :varActionId,
                        })
                    }else{
                        this.setState({
                            actionId :varActionId,
                            disabledHead:false
                        })
                    }
                }
            }, 5000);
        }
    }

    handleCloseModal() {
        this.setState({modalShow: false});
    }

    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }
    handleOnBindCustomAction(actionId, row){
        if(actionId === 'Download'){
            if(row.get('status') == 'Completed' && row.get('reportLinkDetail')!="" && (!row.get('part') || row.get('part') <= 1)){
                return true;
            }
        }
        if(actionId === 'Download2'){
            if(row.get('status') == 'Completed' && row.get('reportLinkSummary')!=""){
                return true;
            }
        }
        if(actionId === 'Split'){
            if(row.get('status') == 'Completed' && row.get('reportLinkDetail')!="" && row.get('part') > 1){
                return true;
            }
        }
        if(actionId=='Refresh'){
            if(row.get('status') != 'Completed'){
                return true;
            }
        }
        if(actionId=='Hover'){
                return true;
        }

        return false;
    }
    async handleCustomAction(id, row){
        switch(id){
            case "Download":
                this.props.actionDownload(row.get('requestid'), 'detail', 1);
                break;
            case "Split":
                this.setState({modalShow: true, modalType: 'detail', modalData: row});
                break;
            case "Download2":
                this.props.actionDownload(row.get('requestid'), 'summary', 1);
                break;
            case "Refresh":
                this.refreshGrid(1, this.state.formSearch);
            break;
            default:
        }
    }
    handleCancelForm(refresh){
        if(refresh){
            this.handleFindSearch(1);
        }
        this.setState({ 
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew(){
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.props.actionDownload(value.get('requestid'))   
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }


    refreshGrid(page, search){
        this.handleFindSearch(page);
        //toast.success('Data Update Success!', toast.POSITION.TOP_RIGHT);
    }


    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field,value);
        if(field === 'client-id'){
            if(value) {
                this.setState({client_id: value})
                this.props.actionGetAllDivision(value, 'Report Button');
            } else {
                formVal = formVal.set('division-id', null);
                this.props.actionGetAllDivision(-1, 'Report Button');
            }
        }
        this.setState({ searchForm:formVal })
        if(field == 'start-date'){
            let formEndDate = formVal.set('end-date', value)
            this.setState({searchForm:formEndDate})
        }

    }
    handleFind(){
        this.handleFindSearch(1);
    }

    handleFindSearch(page){
        const {searchForm,isadmin} = this.state;
        let client_id = searchForm.get('client-id');
        let division_id = searchForm.get('division-id');
        let status = searchForm.get('status');
        let start_date = searchForm.get('start-date');
        let end_date = searchForm.get('end-date');
        var bodyFInd = {};

        if (PrevilageId != 1 && isadmin == false && (client_id == "" || client_id == null || client_id == undefined)) client_id = ClientId;
        if (PrevilageId != 1 && isadmin == false && (division_id == "" || division_id == null || division_id == undefined)) division_id = DivisionId;

        if ((PrevilageId == 1 || isadmin == true) && client_id == "") client_id = 0;
        if ((PrevilageId == 1 || isadmin == true) && division_id == "") division_id = 0;

        bodyFInd = {
            "client-id":client_id,
            "division-id" : division_id,
            "status": status,
            "start-date" : start_date,
            "end-date" : end_date,
        }
        this.props.actionGet(page,this.state.sortForm, bodyFInd);
    }

    showContent(){
        var form = this.state.form;

        if(form.get('show')){
            return(
                <Form 
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }
                >
                </Form>
            )
        }else{
            const items = this.props.reportbuttonlist ? fromJS(this.props.reportbuttonlist) : fromJS({});
            const part = this.state.modalData.get('part');
        
            var btnItem = [];
            for(var i = 0; i < part; i++) {
                btnItem.push(i+1);
            }

            return (
                <div>
                    <CustomGrid
                        title="Report Button"
                        columns={ this.state.columns  } 
                        items={ items }  
                        search={ this.state.search }
                        handleSearch={ this.handleSearch }
                        handleViewClicked={this.handleViewClicked}
                        handleOnBindCustomAction={ this.handleOnBindCustomAction }
                        handleCustomAction={ this.handleCustomAction }
                        handlePageChanged={this.handlePageChanged}
                    >
                    </CustomGrid>

                    {/* Modal Split File */}
                    <Modal show={this.state.modalShow} onHide={this.handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>{this.state.modalData.get('file-name')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {
                                btnItem.map((item, index) => {
                                    return(
                                        <button type="button"
                                            className="btn btn-success mb-2"
                                            onClick={() => this.props.actionDownload(this.state.modalData.get('requestid'), this.state.modalType, item)}
                                            >
                                            Part{item}
                                        </button>
                                    )
                                })
                            }
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button"
                                className="btn btn-wide btn-danger"
                                onClick={this.handleCloseModal}>
                                Close
                            </button>
                        </Modal.Footer>
                    </Modal>
                </div>
            )
        }
    }

    render(){
        const { form, searchForm, errors } = this.state;
        const title = form.get('show') ? ( form.get('actionType') === IsCreate ? "Add Report Button"  : "Edit Report Button"  ) : "Report Button";
        const classHide = title == 'Report Button' ?  'card' : 'card hidden'
        var ctDataAkses = this.state.actionId;
        if(ctDataAkses==="" || ctDataAkses===undefined){
            this.settingActionId();
        }
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        { title }
                    </h4>
                </div>
                <div className=  {classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    disabled={this.state.disabledHead}
                                    placeholder="Client"
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='division-id'
                                    value={searchForm.get('division-id')}
                                    options={fromJS({
                                        'source': this.props.divisionall,
                                        'value': 'division-id',
                                        'label': 'division-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Division"
                                    disabled={this.state.disabledHead}
                                    hasError={errors.has('division-id')}
                                />
                            </div>

                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='status'
                                    value={searchForm.get('status')}
                                    options={fromJS({
                                        'source': this.state.status,
                                        'value': 'value',
                                        'label': 'label'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Status"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('status')}
                                />
                            </div>
                            <span className="col-sm-1">Start</span>
                            <div className="col-sm-2">
                                <DatePickerInput
                                    dateFormat="yyyy-MM-dd"
                                    convertvalue
                                    field="start-date"
                                    value={ searchForm.get('start-date') }
                                    onChange={(field, date) => this.handleChange(field, date)}
                                />
                            </div>
                            <span className="col-sm-1">End</span>
                            <div className="col-sm-2">
                                <DatePickerInput
                                    convertvalue
                                    dateFormat="yyyy-MM-dd"
                                    field="end-date"
                                    value={ searchForm.get('end-date') }
                                    onChange={(field, date) => this.handleChange(field, date)}
                                    minDate={new Date(searchForm.get('start-date'))}
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success"
                                        onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success content-add"
                                        onClick={this.handleNew}>
                                    <i className="material-icons">{'add'}</i>{'Add'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
  (state) => {
      return {
          clientall: state.user.clientall,
          divisionall: state.user.divisionall,
          accessmoduleaction: state.user.accessmoduleaction,
          reportbuttonlist:state.user.reportButton
      }
  },
  dispatch => bindActionCreators({
      actionGet: ActionGet,
      actionGetAllClient:ActionGetAllClient,
      actionGetAllDivision: ActionGetAllDivision,
      actionDownload: ActionDownload,
      actionGetAccessModuleIdAction:ActionGetAccessModuleIdAction,
      actionFindByGroupId:ActionFindByGroupId,
  }, dispatch),
)(Page);